<template>
  <LayoutBasic
    :showLinksMenu="false"
    v-if="producto"
    :routeBack="-1"
  >
    <!-- Título del producto -->
    <template v-slot:title> </template>
    <template #navigation-title>
      <div class="text-h6 font-weight-bold">Productos de la empresa</div>
    </template>

    <!-- Secciones tipo dashboard -->
    <template v-slot:navigation-content>
      <v-img
        :src="
          producto.imagen_principal ||
          require('@/assets/no-image.png')
        "
        aspect-ratio="1"
        height="200"
        contain
        class="rounded-lg"
        style="object-fit: contain"
      />

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <div style="font-size: 20px" class="text-wrap">
              <b>{{ producto.descripcion_comercial }}</b>
            </div>
            <div class="mt-1" v-if="producto.es_elaboracion_propia">
              <v-chip
                small
                outlined
                color="green lighten-3"
                text-color="green darken-2"
                class="font-weight-medium"
              >
                <v-icon left small>mdi-factory</v-icon>
                Elaboración propia
              </v-chip>
            </div>
          </v-list-item-title>
          <v-list-item-subtitle class="mt-1">
            Actualizado el
            {{ moment(producto.fechaActualizacion).format("ll") }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'empresa.producto.detalle' }" exact>
        <v-list-item-icon>
          <v-icon>mdi-information-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Información</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'empresa.producto.presentaciones' }">
        <v-list-item-icon>
          <v-icon>mdi-package-variant-closed</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Presentaciones</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'empresa.producto.sucursales' }">
        <v-list-item-icon>
          <v-icon>mdi-store-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Sucursales</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-2" dark style="opacity: 0.05" />

      <v-list-item :to="{ name: 'empresa.producto.ayuda' }">
        <v-list-item-icon>
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Ayuda</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="producto.parent && configuracion.productosFraccionados"
      >
        <v-list-item-content>
          <v-list-item-title>Producto base</v-list-item-title>
          <v-list-item-subtitle>
            <v-btn text small @click="changeParam(producto.parent)">
              <b>{{ producto.parent_name.toUpperCase() }}</b>
            </v-btn>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <!-- Vista previa del producto -->
    <template v-slot:vista-previa>
      <v-row
        align="center"
        justify="center"
        v-if="!loadingFetch"
        class="mt-2 mx-auto"
      >
        <v-col cols="12" class="px-0 px-sm-3">
          <!-- En tablet y celular las secciones del sidebar quedan detrás
               del menú: se repiten como tabs arriba del contenido. -->
          <v-tabs
            v-if="!$vuetify.breakpoint.lgAndUp"
            background-color="transparent"
            show-arrows
            class="mb-2"
          >
            <v-tab :to="{ name: 'empresa.producto.detalle' }" exact class="text-none">Información</v-tab>
            <v-tab :to="{ name: 'empresa.producto.presentaciones' }" class="text-none">Presentaciones</v-tab>
            <v-tab :to="{ name: 'empresa.producto.sucursales' }" class="text-none">Sucursales</v-tab>
            <v-tab :to="{ name: 'empresa.producto.ayuda' }" class="text-none">Ayuda</v-tab>
          </v-tabs>
          <v-container class="pa-0 pa-sm-3">
            <router-view
              :productoProp="producto"
              @refresh-producto="fetchProducto($route.params.id_producto)"
            ></router-view>
          </v-container>
        </v-col>
      </v-row>
    </template>
  </LayoutBasic>
</template>
  
<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";
import LayoutProductoItem from "@/layouts/productos/LayoutProductoItem.vue";

import { mapState } from "vuex";
import ProductosAPI from "@/api/productos";

export default {
  name: "ProductoEmpresaLayout",
  components: {
    LayoutProductoItem,
    LayoutBasic,
  },

  data() {
    return {
      loadingFetch: false,
      producto: null,
      loadingProductosFraccionados: false,
      productosFraccionados: null,
    };
  },
  computed: {
    ...mapState("sucursales", ["configuracion"]),
  },

  methods: {
    fetchProductosFraccionados(producto_id) {
      this.loadingProductosFraccionados = true;

      ProductosAPI.showProductosFraccionados(producto_id)
        .then((response) => {
          this.productosFraccionados = response.data;
          this.loadingProductosFraccionados = true;
        })
        .catch((e) => {
          console.log(e);

          this.loadingProductosFraccionados = false;
        });
    },

    fetchProducto(id) {
      this.loadingFetch = true;
      this.producto = null;

      ProductosAPI.show_empresa(id).then((response) => {
        this.producto = response.data;
        this.producto.categoriaArbol
          ? null
          : (this.producto.categoriaArbol = { id: null });
        this.loadingFetch = false;
      });
    },
    changeParam(id) {
      this.$router.replace({ name: "productoHome", params: { id: id } });
      this.fetchProducto(id);
      this.fetchProductosFraccionados(id);
    },
  },
  created() {
    if (this.$route.params.producto === undefined) {
      this.fetchProducto(this.$route.params.id_producto);
      this.fetchProductosFraccionados(this.$route.params.id_producto);
    } else {
      this.loadingFetch = true;
      var producto = this.$route.params.producto;
      if (!producto.categoriaArbol) {
        producto.categoriaArbol = { id: null };
      }

      producto.categoriaArbol = producto.categoriaArbol
        ? producto.categoriaArbol
        : { id: null };
      this.producto = producto;
      this.fetchProductosFraccionados(producto.id);

      this.loadingFetch = false;
    }
  },
};
</script>
  
<style scoped>
</style>
  